import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA4_ID = 'G-CC2486B96D';
let configured = false;

const ensureGtag = () => {
  if (typeof window === 'undefined') return false;
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
  if (!configured) {
    window.gtag('js', new Date());
    window.gtag('config', GA4_ID, { send_page_view: false });
    configured = true;
  }
  return true;
};

/**
 * GA4 page views on first load and on SPA route changes.
 * The previous react-ga (Universal Analytics) call treated the GA4 measurement
 * ID as a userId and never initialised a tracker.
 */
const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (!ensureGtag()) return;
    const path = window.location.pathname + window.location.search;
    window.gtag('event', 'page_view', {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
};

export default Analytics;
